import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import { useGetSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import { securityEventDetailsAttributes } from "security-app/components/SecurityEvents/Alerts/Constants";
import EventDetails from "./EventDetails";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
`;
function Index({
  securityEventId,
  orientation = "horz",
  detailsAttributes = securityEventDetailsAttributes,
  interactiveTags = false
}) {
  const { securityEvent, loadingSecurityEvents } = useGetSecurityEvent(securityEventId);
  const { t } = useTranslation("enterprise_security_events");
  if (loadingSecurityEvents) {
    return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Spinner, { text: t("security_event_loader.loading") }));
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    EventDetails,
    {
      securityEvent,
      orientation,
      detailsAttributes,
      interactiveTags
    }
  ));
}
export default Index;
